module.exports = __webpack_public_path__ + "assets/img/form1.f0132c8c.png";